import useCapabilities from "@/hooks/useCapabilities";
import { isSectionScopedForEvents } from "./_nationalSectionBypass";

/** Section-scoped event UX only when the user lacks a national-bypass role. */
export default function useIsSectionScopedForEvents(): boolean {
  const { loaded, hasRole } = useCapabilities();
  return isSectionScopedForEvents({ loaded, hasRole });
}
